import {Component, Input, OnInit} from '@angular/core';

import {ActivatedRoute} from '@angular/router';

import {
  ClientProfileService,
} from '../../_services/index';

import {MatDialog} from '@angular/material/dialog';
import {Role} from "../../helpers";
import {Constants} from "../../helpers/constants";
import {MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {WorkstreamItemComponent} from "../workstreamItem";
import {WorkstreamService} from "../../_services/workstream.service";
import {ConfirmComponent} from "../confirm";
import {WorkstreamComponent} from "../workstream/workstream.component";
import {UploadComplianceAreaComponent} from "../uploadComplianceArea";
import {WorkstreamUploadComponent} from "../workstreamUpload";
import {
  AddLinkRecommendedSolutionComponent
} from "../addLinkRecommendedSolution/add-link-recommended-solution.component";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {RecommendedSolutionsListComponent} from "../recommendedSolutionsList";
import {ReferenceResourceUploadComponent} from "../referenceResourceUpload";
import {RecommendedSolutionUploadComponent} from "../recommendedSolutionUpload";

@Component({
    standalone: false,
  selector: "recommended-solutions",
  templateUrl: 'recommended-solutions.component.html',
  styleUrls: ['./recommended-solutions.component.scss'],
})

export class RecommendedSolutionsComponent implements OnInit {

  items: any[] = [];
  rowGroupIndexes: any[] = [];
  currentUser: any;
  public dialogRef: MatDialogRef<any, any>;
  cols : any[] = [
    {'field': 'name', 'header': 'Name'},
    {'field': 'description', 'header': 'Description'},
    {'field': 'cost', 'header':'Cost'},
    {'field': 'configDetails', 'header':'Config Details'},
  ]
  exportCols;

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public service: RecommendedSolutionService) {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.exportCols = [{header: 'List', field: 'listName'}].concat(this.cols);
  }

  ngOnInit() {
    this.service.getAll().subscribe(result => {
      this.items = [];
      let i = 0;
      for (let list of result) {
        this.rowGroupIndexes[list.recommendedSolutionsListId] = i;
        if (!list.recommendedSolutions.length) {
          this.items.push({listId: list.recommendedSolutionsListId, listName: list.name, logoFileName: list.logoFileName, 'virtual': true});
          i++;
        } else {
          for (let item of list.recommendedSolutions) {
            item.listName = list.name;
            item.logoFileName = list.logoFileName;
            this.items.push(item);
            i++;
          }
        }
      }
    });
  }

  editItem(item: any) {
    this.edit(AddLinkRecommendedSolutionComponent, item);
  }

  createList() {
    this.edit(RecommendedSolutionsListComponent, {
      name: ""
    });
  }

  createItem(listId) {
    this.edit(AddLinkRecommendedSolutionComponent, {
      listId: listId
    })
  }

  editList(item: any) {
    this.edit(RecommendedSolutionsListComponent, {
      recommendedSolutionsListId: item.listId,
      name: item.listName,
      logoFileName: item.logoFileName
    });
  }

  public edit(component, item: any) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '80%',
      height: '90%',
      data: {
        entity: item
      }
    };

    this.dialogRef = this.dialog.open(component, config);

    this.dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.value) {
        result.value.date = new Date();
        result.value.submitterId = this.currentUser.userId;
        this.service.saveRecommendedSolution(result.value).subscribe(() => {
          this.ngOnInit();
        })
      } else {
        this.ngOnInit();
      }
    });
  }

  public deleteItem(itemId) {
    this.delete('Recommended Solution', (id) => this.doDeleteItem(id), itemId);
  }

  public deleteList(listId) {
    this.delete('Recommended Solutions List', (id) => this.doDeleteList(id), listId);
  }

  public delete(name, callback, item) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Do you want to delete this ' + name + '?',
        yes: 'Yes',
        no: 'No',
        confirm: () => callback(item),
        cancel: () => {
        }
      }
    });
  }

  public doDeleteItem(itemId) {
    this.service.deleteRecommendedSolution(itemId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  public doDeleteList(listId) {
    this.service.deleteList(listId).subscribe(r => {
      this.dialog.closeAll();
      this.ngOnInit();
    })
  }

  getTenantName(): string {
    if (this.currentUser == null) {
      return null;
    }

    if (this.currentUser.role == Role.KingAdmin) {
      return Constants.RiskSpongeMaster;
    }

    return this.currentUser.tenantName;
  }
  importRecommendedSolution() {
    const dialogRef = this.dialog.open(RecommendedSolutionUploadComponent, {});

    dialogRef.afterClosed().subscribe(() => {
      this.ngOnInit();
    });
  }
}
